
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.629 2.029l.01-.014L7.646 2C8.195 1.084 9.233.502 10.375.5 12.026.5 13.5 1.981 13.5 3.657c0 2.04-1.38 3.88-2.989 5.316C9.125 10.21 7.65 11.078 7 11.433c-.65-.355-2.125-1.223-3.511-2.46C1.88 7.536.5 5.697.5 3.657.5 1.98 1.974.5 3.625.5c1.142.002 2.18.584 2.728 1.5l.009.015.01.014c.145.21.385.326.628.326a.764.764 0 00.629-.326z"}})])
          )
        }
      }
    